/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Care_Log_Total_CountInputs */

const vi_care_log_total_count = /** @type {(inputs: Care_Log_Total_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng ${i?.count} nhật ký`)
};

/**

* @param {Care_Log_Total_CountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_total_count = /** @type {((inputs: Care_Log_Total_CountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Total_CountInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_total_count(inputs)
});